module.exports = __webpack_public_path__ + "images/emoji/tanabata_tree.25b10f4abed41f490a7f.png";